<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" secondaryButtonLabel="Cancel"
    primaryButtonLabel="Run Workflow" (primaryButtonActionEmt)="run()" [isPrimaryBtnEnabled]="isPrimaryBtnEnabled()"
    [verifyRequiredValidator]="true" [modalHelpIndex]="modalHelpIndex" (closeButtonActionEmt)="closeModal()"
    [modalClass]="modalClass" [resizeVertical]="false" [resizeVerticalMin]="500" [maximizable]="false"
    [resizeHorizontal]="false" [resizeHorizontalMin]="500" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage">

    <res-custom-checkbox automationId="workflow-reporting-options-generate-workflow-report"
        content="Generate Workflow Report" class="generate" [isDisabled]="true" [(ngModel)]="generateCheckbox">
    </res-custom-checkbox>
    <res-custom-checkbox automationId="workflow-reporting-options-add-final-search-term-report"
        content="Add Final Search Term Report" class="final" [(ngModel)]="finalCheckbox"
        (ngModelChange)="changeFinal()"></res-custom-checkbox>
    <div class="export-row">
        <res-custom-checkbox automationId="workflow-reporting-options-add-export-comparison-report"
            content="Add Export Comparison Report:" [(ngModel)]="exportCheckbox" (ngModelChange)="changeExport()">
        </res-custom-checkbox>
        <input type="text" title="{{export.name}}" readonly class="read-only" [ngModel]="export.name"
            data-automation-id="workflow-reporting-options-export-name-label">
        <button type="button" class="secondary-button select-export-button" (click)="launchPicker()"
            [disabled]="!exportCheckbox" data-automation-id="workflow-reporting-options-select-export-button">
            <span>Select Export ...</span>
        </button>
    </div>

</res-base-modal>